import { getHeaders, getUserDetails } from 'auth/auth';
import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../baseQuery';

//admin API'S
export const adminEmployeeAPI = createApi({
  reducerPath: 'adminEmployee',
  tagTypes: ['fetchAdminEmployees', 'adminEmployeeUpdate'],
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    //get admin - consumer data
    getEmployee: builder.query({
      query: ({ paging, searchFilter }) => {
        const { limit, offset } = paging;
        return {
          url: `b2b/loan/employee/?page_number=${offset}&page_size=${limit}&search=${searchFilter || ''}`,
          method: 'GET',
          headers: getHeaders(),
        };
      },
      providesTags: ['fetchAdminEmployees'],
    }),
    getEmployeeType: builder.query({
      query: () => {
        return {
          url: `/b2b/loan/application_dropdowns/employee_types`,
          method: 'GET',
          headers: getHeaders(),
        };
      },
    }),
    resetPassword: builder.mutation({
      query: ({ user_id }) => {
        return {
          url: `b2b/loan/employee/reset_password?user_id=${user_id}`,
          method: 'POST',
          headers: getHeaders(),
          //body: data,
        };
      },
    }),
    updateEmployee: builder.mutation({
      query: ({ image, user_id, data }) => {
        const formData = new FormData();

        formData.append('file', image);
        Object.keys(data).forEach((key) => {
          formData.append(key, data[key]);
        });
        formData.append('employeeTypeId', data.employeeTypeId);
        formData.append('company', data.companyName);

        formData.delete('companyName');
        const headers = getHeaders();
        delete headers['Content-Type'];
        delete headers['content-type'];

        return {
          url: `b2b/loan/employee/${user_id}`,
          method: 'PUT',
          headers: headers,
          body: formData,
        };
      },
      invalidatesTags: ['fetchAdminEmployees'],
    }),

    createEmployee: builder.mutation({
      query: ({ data, image }) => {
        const formData = new FormData();
        formData.append('file', image);
        Object.keys(data).forEach((key) => {
          formData.append(key, data[key]);
        });
        formData.append('employeeTypeId', data.employeeTypeId);
        formData.append('company', data.companyName);

        formData.delete('companyName');

        const headers = getHeaders();
        delete headers['Content-Type'];
        delete headers['content-type'];
        return {
          url: `b2b/loan/employee/`,
          method: 'POST',
          headers: headers,
          body: formData,
        };
      },
      invalidatesTags: ['fetchAdminEmployees'],
    }),

    deleteEmployee: builder.mutation({
      query: ({ userId }) => {
        return {
          url: `b2b/loan/employee/${userId}`,
          method: 'DELETE',
          headers: getHeaders(),
        };
      },
      invalidatesTags: ['fetchAdminEmployees'],
    }),
    // get state
    getStates: builder.query({
      query: () => {
        return {
          url: `/b2b/loan/application_dropdowns/states`,
          method: 'GET',
          headers: getHeaders(),
        };
      },
    }),
  }),
});

export const {
  useGetEmployeeQuery,
  useGetEmployeeTypeQuery,
  useResetPasswordMutation,
  useUpdateEmployeeMutation,
  useDeleteEmployeeMutation,
  useCreateEmployeeMutation,
  useGetStatesQuery,
} = adminEmployeeAPI;
